<app-base-modal
  [title]="advertisementInitialStatisticsResourceType.name"
  [modalMaxHeight]="'90vh'"
  [showStateToggle]="true"
>
  <form
    class="initial-advertisement-statistics-form"
    [formGroup]="formGroup"
  >
    @for (row of advertisementInitialStatisticsRowKeys; track $index) {
      @if (visibleRow(row)) {
        <div [class]="row.className">
          @for (field of getFieldsByRowKey(row.key); track $index) {
            @switch (field.type) {
              @case ('number') {
                @if (field.noEdit) {
                  <mat-form-field
                    appearance="outline"
                    class="initial-advertisement-statistics-field none-pointer-events"
                  >
                    <mat-label>
                      {{ field.label }}
                    </mat-label>
                    <input
                      matInput
                      type="number"
                      [formControlName]="field.fieldName"
                    >
                    @if (field.needMatTextSuffix) {
                      <span matTextSuffix>
                        {{ field.matTextSuffixValue }}
                      </span>
                    }
                  </mat-form-field>
                } @else {
                  <mat-form-field
                    appearance="outline"
                    class="initial-advertisement-statistics-field"
                    [class]="setFieldClasses()"
                  >
                    <mat-label>
                      {{ field.label }}
                    </mat-label>
                    @if (isEditModeActive) {
                      <input
                        matInput
                        [type]="field.inputType || 'text'"
                        [placeholder]="field.placeholder || ''"
                        [formControlName]="field.fieldName"
                        (blur)="handleRecordUpdate(field.fieldName)"
                        (change)="handleRecordUpdate(field.fieldName)"
                        (keydown)="preventInvalidNumericInput($event, field.isDecimalPoint)"
                        (input)="preventDecimalInput($event, field.fieldName, field.useLimits)"
                      >
                    } @else {
                      <input
                        matInput
                        readonly
                        [value]="formatBudgetValue(field.fieldName, field.needMaximumFractionDigits)"
                      >
                    }
                    @if (field.needMatTextSuffix) {
                      <span matTextSuffix>
                        {{ field.matTextSuffixValue }}
                      </span>
                    }
                  </mat-form-field>
                }
              }
              @case ('select') {
                <mat-form-field
                  appearance="outline"
                  class="initial-advertisement-statistics-field"
                  [class]="setFieldClasses()"
                >
                  <mat-label>
                    {{ field.label }}
                  </mat-label>
                  <mat-select
                    [formControlName]="field.fieldName"
                    (selectionChange)="handleChange($event.value, field.fieldName)"
                  >
                    <mat-option></mat-option>
                    @for (option of getSelectDataByFieldName(field.fieldName); track $index) {
                      <mat-option [value]="option.id">
                        {{ option.value }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @case ('toggleGroup') {
                <mat-button-toggle-group
                  [class]="setFieldClasses()"
                  [formControlName]="field.fieldName"
                  (change)="handleChange($event.value, field.fieldName)"
                >
                  @for (option of gender; track $index) {
                    <mat-button-toggle [value]="option.id">
                      {{ option.label }}
                    </mat-button-toggle>
                  }
                </mat-button-toggle-group>
              }
              @case ('text') {
                <mat-form-field
                  appearance="outline"
                  class="initial-advertisement-statistics-field"
                  [class]="setFieldClasses()"
                  [style]="getFieldStyles({ formControlName: field.fieldName, formGroup })"
                  (click)="handleValueClick({ formControlName: field.fieldName, formGroup })"
                >
                  <mat-label>
                    {{ field.label }}
                  </mat-label>
                  <input
                    matInput
                    [type]="field.inputType || 'text'"
                    [formControlName]="field.fieldName"
                    (blur)="handleRecordUpdate(field.fieldName)"
                    (change)="handleRecordUpdate(field.fieldName)"
                  >
                </mat-form-field>
              }
              @case ('button') {
                <button
                  [appIconStatus]="fetchIconStatus()"
                  mat-stroked-button
                  color="primary"
                  class="initial-advertisement-statistics-btn"
                  (click)="handleFileAction()"
                >
                  Файлы
                </button>
              }
            }
          }
        </div>
      }
    }
  </form>
</app-base-modal>
